module.exports = __webpack_public_path__ + "img/clipboard-check.69e29172.svg";